import StatusFilterController from "../filtering/status-filter-controller";

export default class extends StatusFilterController {
  newURLFor(status) {
    return App.Helpers.addParamsToURL(this.url, {tab: 'All', status});
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/involvement/involvement-company-controller.js